import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAssets, goToPreviousPage, resetFetchStatus } from './assetSlice';
import { Link } from 'react-router-dom';

const Assets = () => {
    const dispatch = useDispatch();
    const { assets, nextPageToken, pageTokens, fetchStatus } = useSelector((state) => state.asset);

    useEffect(() => {
      console.log('fetchStatus:', fetchStatus);
        dispatch(fetchAssets({ nextPageToken: null })); // First page fetch
        if (fetchStatus === 'succeeded') {
            dispatch(resetFetchStatus());
        }
    }, [dispatch, fetchStatus]);

    const handleNextPage = () => {
        if (nextPageToken) dispatch(fetchAssets({ nextPageToken }));
    };

    const handlePreviousPage = () => {
        if (pageTokens.length > 1) dispatch(goToPreviousPage());
    };

    return (
        <div>
            <h2>Assets</h2>
            <Link to="/add-asset">Add New Asset</Link>
            {fetchStatus === 'loading' && <p>Loading...</p>}
            {fetchStatus === 'succeeded' &&
                assets.map((asset) => (
                    <div key={asset.assetId}>
                        <h3>
                          <Link to={`/assets/${asset.assetId}`}>{asset.name}</Link>
                        </h3>
                        <p>Symbol: {asset.symbol}</p>
                        <p>Type: {asset.assetType}</p>
                    </div>
                ))}
            <div>
                <button onClick={handlePreviousPage} disabled={pageTokens.length <= 1}>
                    Previous
                </button>
                <button onClick={handleNextPage} disabled={!nextPageToken}>
                    Next
                </button>
            </div>
        </div>
    );
};

export default Assets;